// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as AuthStore$PorterinFeature from "../../../../containers/login/domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../../containers/login/domain/helpers/AuthUtils.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as ModalContext$PorterinFeature from "../../../../contexts/modal-context/ModalContext.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../containers/login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as AddressContext$PorterinFeature from "../../../../contexts/address-context/AddressContext.mjs";
import * as MobileLoginModuleScss from "../styles/MobileLogin.module.scss";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as FareEstimateHelperV1$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/repo/FareEstimateHelperV1.mjs";
import * as FareEstimateV2Helper$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/helpers/FareEstimateV2Helper.mjs";
import * as FareEstimateContextV1$PorterinFeature from "../../../../contexts/fare-estimate-context/FareEstimateContextV1.mjs";

var styles = MobileLoginModuleScss;

function MobileLoginCmp(Props) {
  var router = Router.useRouter();
  var match = ModalContext$PorterinFeature.useModalContext(undefined);
  var toggleModal = match.toggleModal;
  var match$1 = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var category = match$1.category;
  var authContext = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var user = authContext.user;
  var is_authenticated = authContext.is_authenticated;
  var match$2 = AddressContext$PorterinFeature.useAddressContext(undefined);
  var receiver = match$2.receiver;
  var sender = match$2.sender;
  var fareEstimateContext = FareEstimateContextV1$PorterinFeature.useFareEstimateContext(undefined);
  if (is_authenticated) {
    return React.createElement("div", {
                className: styles["user-details"]
              }, React.createElement("div", {
                    className: styles.name
                  }, Belt_Option.getWithDefault(AuthUtils$PorterinFeature.name(user), AuthStore$PorterinFeature.Header.login_button_text_desktop)), React.createElement("div", {
                    className: styles.email
                  }, Belt_Option.getWithDefault(AuthUtils$PorterinFeature.email(user), "N.A.")));
  } else {
    return React.createElement(React.Fragment, undefined, router.pathname === Config$PorterinUtils.internal_path ? React.createElement("button", {
                      className: styles["login-button"],
                      onClick: (function (param) {
                          var redirectUrl = FareEstimateV2Helper$PorterinFeature.orderReviewLinkCreator(sender, receiver, fareEstimateContext.selected_vehicle, user);
                          var redirectCb = function (param) {
                            FareEstimateHelperV1$PorterinFeature.redirectOrderReview(redirectUrl);
                          };
                          if (is_authenticated) {
                            Curry._1(toggleModal, {
                                  TAG: /* Auth */11,
                                  _0: true,
                                  _1: /* Profile */3,
                                  _2: undefined,
                                  _3: authContext,
                                  _4: redirectCb
                                });
                          } else {
                            Curry._1(toggleModal, {
                                  TAG: /* Auth */11,
                                  _0: true,
                                  _1: /* LoginScreen */{
                                    _0: undefined,
                                    _1: false
                                  },
                                  _2: undefined,
                                  _3: authContext,
                                  _4: redirectCb
                                });
                          }
                          PublishEventsHelper$PorterinFeature.publishEvents(category, AuthStore$PorterinFeature.Header.ga_login_button_click, undefined);
                        })
                    }, AuthStore$PorterinFeature.login_button) : null);
  }
}

var make = MobileLoginCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
